import React from "react";


const InsCompanyCard = ({doctor, company}) => {
    return (
        <label className="tag-widget-ins">{company.name}</label>
    )
};
export default InsCompanyCard;